export default __webpack_public_path__ + "static/media/img1_1.8c45b28c.jpg";